import ADUH_LOGO from "_Mobile/assets/aduh/ADUH.png";
import MAP from "_Mobile/assets/aduh/sotoaduh_map.png";
import DIRECTIONS from "_Mobile/assets/aduh/sotoaduh_directions.png"
// import ADUH_DISKON from "_Mobile/assets/aduh/aduh_diskon.png";
import CTA from "_Mobile/assets/aduh/aduh_CTA.png";
import { Link } from 'react-router-dom';
import MobileAduhAddress from "_Mobile/components/Aduh/Address";
import "./style.css";

const MobileAduhLokasi = () => (
  <div className="Aduh MobileAduhLokasi">
    <div className="header">
      <Link to="/aduh">
        <img className="logo" src={ADUH_LOGO} alt="" />
      </Link>
      <div className="subtitle">Lokasi</div>
    </div>
    <p style={{ lineHeight: '1.1', fontSize: '16px' }}>
      1101 KINGSFORD INDUSTRIAL CENTRE<br />
      13 WANG HOI ROAD KOWLOON BAY
    </p>
    <img className="aduh96" src={MAP} alt="" />
    <img className="aduh96" src={DIRECTIONS} alt="" />
    <a aria-label="Chat on WhatsApp" href="https://wa.me/60283591" target="_blank" rel="noopener noreferrer">
      <div className="CTA_wrapper">
        <img className="CTA" src={CTA} alt="" />
      </div>
    </a>
    <MobileAduhAddress />
  </div>
);

export default MobileAduhLokasi;